// Add your custom JS here.

var canProcessWheel = [];
var mouseIsOverCarousel = [];

window.addEventListener('load', function() {

    function positionArrows(carouselID)
    {
        var images = jQuery('.glider[data-carousel-id="' + carouselID + '"] img');
        var cards = jQuery('.glider[data-carousel-id="' + carouselID + '"] .card');
        var menuItems = jQuery('.glider[data-carousel-id="' + carouselID + '"] .menu-item');

        var imageHeight = 350;

        if (images.length > 0) {
            imageHeight = images[0].clientHeight;
        } else if (cards.length > 0) {
            imageHeight = cards[0].clientHeight;
        } else if (menuItems.length > 0) {
            imageHeight = menuItems[0].clientHeight;
        }

        var arrowImageHeight = jQuery('.glider-arrow--previous-' + carouselID)[0].clientHeight;
        var arrowPositionAdjustment = jQuery('.glider-arrow--previous-' + carouselID).attr('data-position-adjustment');
        if (!arrowPositionAdjustment) arrowPositionAdjustment = 0;

        jQuery('.glider-arrow--previous-' + carouselID).css('top', (imageHeight / 2 - arrowImageHeight / 2 + parseInt(arrowPositionAdjustment)) + 'px');
        jQuery('.glider-arrow--next-' + carouselID).css('top', (imageHeight / 2 - arrowImageHeight / 2 + parseInt(arrowPositionAdjustment)) + 'px');
    }

    /**
     * Re-calculate bleed scroll windows (used for carousels)
     */
    function recalculateBleedScrollWindow() {

        var clientWidth = document.body.clientWidth;

        [].forEach.call(document.querySelectorAll('.glider'), function (ele) {

            // Extract glider ID from DOM - usually generated as md5(time() . rand(0, 100))
            var gliderID = jQuery(ele).attr('data-carousel-id');

            // Only set calculated width if the viewport is at least 992 pixels
            if  (clientWidth > 992) {

                // Get width of website container
                var gliderContainer = jQuery('#main-nav .container').width();
                // Calculate left margin of container
                var gliderLeftMargin = (document.body.clientWidth - gliderContainer) / 2;
                // Read (from DOM) number of columns that the glider occupies
                var gliderNumberOfColumns = jQuery('[data-carousel-id=' + gliderID + ']').attr('data-carousel-columns');
                // Browser's scrollbar width
                var browserScrollBarWidth = 16;
                // If number of columns is not specified in DOM (data-carousel-columns data attribute), set it to 10
                if (!gliderNumberOfColumns) gliderNumberOfColumns = 10;
                // Set number of columns for glider to 5 if sidebar is enabled
                if (prospaSettings.hasOwnProperty('sidebar-enabled') && prospaSettings['sidebar-enabled'] == '1') {
                    gliderNumberOfColumns = 5;
                }
                // Set the width of the glider's container to make it so that it touches right side of the browser window
                jQuery('.glider__bleed_container-' + gliderID).css('width', 'calc(100vw - ' + (gliderLeftMargin + (gliderContainer / 12) * (12 - gliderNumberOfColumns) + browserScrollBarWidth) + 'px)');
            } else {

                // If the viewport is small, just make the glider be as wide as website container
                jQuery('.glider__bleed_container-' + gliderID).css('width', 'auto');

            }

            canProcessWheel[gliderID] = true;

            new Glider(ele, {
                slidesToScroll: 1,
                exactWidth: true,
                itemWidth: 262,
                draggable: true,
                dragVelocity: 1,
                duration: 1,
                // dots: '.glider-dots-' + carouselID,
                arrows: {
                    prev: '.glider-arrow--previous-' + gliderID,
                    next: '.glider-arrow--next-' + gliderID,
                },
                responsive: [{
                    // screens greater than >= 576px
                    breakpoint: 576,
                    settings: {
                        slidesToScroll: 1,
                        itemWidth: 350
                    }
                }, {
                    // screens greater than >= 992px
                    breakpoint: 992,
                    settings: {
                        slidesToScroll: 1,
                        itemWidth: 320
                    }
                }, {
                    // screens greater than >= 1200px
                    breakpoint: 1200,
                    settings: {
                        slidesToScroll: 1,
                        itemWidth: 340
                    }
                }, {
                    // screens greater than >= 1024px
                    breakpoint: 1400,
                    settings: {
                        slidesToScroll: 1,
                        itemWidth: 406
                    }
                }]
            });

            jQuery('.glider__bleed_container').show();

            if (window.innerWidth > 992) {

                // Only process mouse wheel scroll for larger screens
                bindWheelEventSimple(gliderID);

                jQuery('[data-carousel-id=' + gliderID + ']').on('glider-animated', function(event){
                    canProcessWheel[gliderID] = true;
                });
            }

            setTimeout( function() { positionArrows(gliderID) }, 400);

        });

    }

    recalculateBleedScrollWindow();

    jQuery(window).on('resize', function() {
        recalculateBleedScrollWindow();
    });

    function bindWheelEventSimple(carouselID)
    {
        jQuery('[data-carousel-id=' + carouselID + ']').on('mousewheel', function (event) {

            // window.console.log('Processing mousewheel event');
            var glider = jQuery(this);

            // Full width of the carousel including hidden bits
            var fullWidth = glider[0].scrollWidth;

            // Width of the visible part of the carousel
            var visibleWidth = glider[0].clientWidth;

            // Amount of carousel that is scrolled away to the left
            var scrollLeft = glider[0].scrollLeft;

            // Check if we have reached the end or the beginning of the carousel

            if (event.originalEvent.deltaY > 0 && visibleWidth + scrollLeft >= fullWidth) {
                // Unbind the mouse wheel event on the carousel
                // window.console.log('Unbind the mouse wheel event on the carousel');
                jQuery('.glider-arrow--next-' + carouselID).addClass('disabled');
                return true;
            }

            if (event.originalEvent.deltaY < 0 && scrollLeft === 0) {
                // Unbind the mouse wheel event on the carousel
                // window.console.log('Unbind the mouse wheel event on the carousel');
                jQuery('.glider-arrow--previous-' + carouselID).addClass('disabled');
                return true;
            }

            // --------------------- START: Debounce ------------------

            // Debouncing the processing of the wheel scroll event
            if (!canProcessWheel[carouselID]) {
                event.preventDefault();
                // window.console.log('Skipping processing...');
                return false;
            }
            // -------------------- END: Debounce ----------------------

            // Double check that mouse cursor is over the carousel
            // var mouseIsOverCarousel = false;
            mouseIsOverCarousel[carouselID] = false;
            var divRect = document.querySelector('[data-carousel-id="' + carouselID + '"]').getBoundingClientRect();
            if (event.clientX >= divRect.left && event.clientX <= divRect.right && event.clientY >= divRect.top && event.clientY <= divRect.bottom) {
                // Mouse is inside element.
                mouseIsOverCarousel[carouselID] = true;
                // window.console.log(mouseIsOverCarousel);
            }

            if (event.originalEvent.deltaY > 1 && mouseIsOverCarousel[carouselID]) {
                // Wheel scrolled up (scroll carousel to the right)
                jQuery('.glider-arrow--next-' + carouselID).trigger('click');
                // window.console.log('Scrolling right - ' + carouselID);
                canProcessWheel[carouselID] = false;
            } else if (event.originalEvent.deltaY < -1 && mouseIsOverCarousel[carouselID]) {
                // Wheel scrolled down (scroll carousel to the left)
                jQuery('.glider-arrow--previous-' + carouselID).trigger('click');
                // window.console.log('Scrolling left - ' + carouselID);
                canProcessWheel[carouselID] = false;
            }

            return false;
        });

    }




});

class ProspaCarousel {

    constructor(uid)
    {
        // window.console.log('Initialising carousel: ', uid);

        this.easeMethod = 'power2.out';
        this.revealAnimationDuration = 0.5;
        this.hideAnimationDuration = 0.2;
        this.hideDelayAmount = 0;
        this.lengthMultiplier = 1;
        // this.easeMethod = '';
        this.carouselUID = uid;

        this.slidesArray = window.gsap.utils.toArray('#carousel-' + this.carouselUID + ' .slide');
        this.numberOfSlides = this.slidesArray.length;
        // this.slideDOMElementHeight = document.querySelector('#carousel-' + this.carouselUID).clientHeight;
        this.slideDOMElementHeight = document.querySelector('#carousel-' + this.carouselUID + ' .slide .slide-bounds').clientHeight;
        this.sliderHeight = this.slideDOMElementHeight * this.numberOfSlides * this.lengthMultiplier;
        this.direction = 1;

        this.scrollTrigger = window.ScrollTrigger;
        this.gsap = window.gsap;
        this.initScrollTrigger();
    }

    getDirection(self) {
        this.direction = self.direction;
    }

    playRevealAnimation(index, direction)
    {
        // window.console.log('Showing', index + 1);

        var revealAnimation = this.gsap.timeline({paused: true, ease: this.easeMethod });
        var mult = direction;

        var clickedDot = window.jQuery("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-dots li:nth-child(" + (index + 1) + ") a");

        var gaPayload = {
            'event': clickedDot.attr('data-ga-event'),
            'eventCategory': clickedDot.attr('data-ga-event-category'),
            'eventAction': clickedDot.attr('data-ga-event-action'),
            'eventLabel': clickedDot.attr('data-ga-event-label')
        };

        if (window.dataLayer) {
            window.dataLayer.push(gaPayload);
        } else {
            window.console.log('Pushing...', gaPayload);
        }

        revealAnimation.set("#carousel-" + this.carouselUID + " .slide--" + (index + 1), { zIndex: 10, overwrite: true }, this.hideDelayAmount);
        revealAnimation.set("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-dots", { opacity: 1, overwrite: true });
        revealAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-image", { y: 60 * mult, opacity: 0 }, { delay: 0.1, y: 0, opacity: 1, duration: this.revealAnimationDuration, overwrite: true }, this.hideDelayAmount * 5);
        revealAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-h1", { y: 120 * mult, opacity: 0 }, { delay: 0.15, y: 0, opacity: 1, duration: this.revealAnimationDuration, overwrite: true }, this.hideDelayAmount);
        revealAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-h4", { y: 30 * mult, opacity: 0 }, { delay: 0.2, y: 0, opacity: 1, duration: this.revealAnimationDuration, overwrite: true}, this.hideDelayAmount);
        revealAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-p", { y: 30 * mult, opacity: 0 }, { delay: 0.25, y: 0, opacity: 1, duration: this.revealAnimationDuration, overwrite: true}, this.hideDelayAmount);
        revealAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-button", { y: 30 * mult, opacity: 0 }, { y: 0, opacity: 1, duration: this.revealAnimationDuration, overwrite: true}, this.hideDelayAmount);


        revealAnimation.restart().play();
    }

    playHideAnimation(index, direction)
    {
        // window.console.log('Hiding', index + 1);

        var hideAnimation = this.gsap.timeline({paused: true, ease: this.easeMethod, overwrite: true});
        var mult = direction;

        hideAnimation.set("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-dots", { opacity: 0, overwrite: true });
        hideAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-image", { y: 0, opacity: 1 }, { y: -60 * mult, opacity: 0, duration: this.hideAnimationDuration / 1.2, overwrite: true }, 0);
        hideAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-h1", { y: 0, opacity: 1 }, { y: -120 * mult, opacity: 0, duration: this.hideAnimationDuration, overwrite: true}, 0);
        hideAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-h4", { y: 0, opacity: 1 }, { y: -30 * mult, opacity: 0, duration: this.hideAnimationDuration, overwrite: true}, 0);
        hideAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-p", { y: 0, opacity: 1 }, { y: -30 * mult, opacity: 0, duration: this.hideAnimationDuration, overwrite: true}, 0);
        hideAnimation.fromTo("#carousel-" + this.carouselUID + " .slide--" + (index + 1) + " .slide-button", { y: 0, opacity: 1 }, { y: -30 * mult, opacity: 0, duration: this.hideAnimationDuration, overwrite: true}, 0);
        hideAnimation.set("#carousel-" + this.carouselUID + " .slide--" + (index + 1), { zIndex: 1, overwrite: true }, 0);

        hideAnimation.restart().play();
    }

    initScrollTrigger()
    {
        var classThis = this;

        this.scrollTrigger.matchMedia({

            // desktop
            "(min-width: 992px)": function () {

                var tl = classThis.gsap.timeline({});

                tl = classThis.gsap.timeline({
                    scrollTrigger: {
                        trigger: "#carousel-" + classThis.carouselUID,
                        start: "top top",
                        end: "bottom+=" + classThis.sliderHeight + "px top",
                        scrub: true,
                        pin: true,
                        markers: false,
                        onUpdate: (self) => { classThis.getDirection(self) }
                    }
                });

                classThis.slidesArray.forEach((section, index) => {

                    tl.add(function() {
                        if (index > 0 ) {
                            classThis.getDirection(tl.scrollTrigger);
                            if(classThis.direction > 0) {
                                classThis.playRevealAnimation(index, classThis.direction);
                            } else {
                                classThis.playHideAnimation(index, classThis.direction);
                            }
                        }
                    })

                    tl.to({}, {})

                    tl.add(function() {
                        if (index + 1 < classThis.numberOfSlides) {
                            classThis.getDirection(tl.scrollTrigger);
                            if(classThis.direction > 0) {
                                classThis.playHideAnimation(index, classThis.direction);
                            } else {
                                classThis.playRevealAnimation(index, classThis.direction);
                            }
                        }
                    });

                });

                var navList = document.querySelectorAll('#carousel-' + classThis.carouselUID + ' .slick-dots li');

                // Make the carousel change slides when clicking on carousel navigation
                navList.forEach((a, i) => {
                    var st = tl.scrollTrigger;
                    var progress = i % classThis.numberOfSlides + 1;

                    a.addEventListener('click', (e) => {
                        e.preventDefault();
                        window.scrolledViaClick = true;
                        classThis.gsap.set(window, {
                            scrollTo: {
                                y: st.start + progress * (st.end - st.start) / classThis.numberOfSlides - 50,
                                smooth: false
                            }
                        });
                    });
                });

            }
        });
    }
}


export { ProspaCarousel };